<template>
  <div>
    <div class="columns">
      <div class="column is-7">
        <div class="field">
          <label class="label">Naam bedrijf</label>
          <div class="control">
            <input class="input" type="text" v-model="settings['company.name']">
          </div>
        </div>

        <div class="columns no-margin-bottom">
          <div class="field column">
            <label class="label">Adres</label>
            <div class="control">
              <input class="input" type="text" v-model="settings['company.address']">
            </div>
          </div>

          <div class="field column">
            <label class="label">Stad</label>
            <div class="control">
              <input class="input" type="text" v-model="settings['company.city']">
            </div>
          </div>
        </div>

        <div class="field">
          <label class="label">Land</label>
          <div class="control">
            <input class="input" type="text" v-model="settings['company.country']">
          </div>
        </div>

        <div class="field">
          <label class="label">IBAN</label>
          <div class="control">
            <input class="input" type="text" v-model="settings['company.iban']">
          </div>
        </div>

        <div class="field">
          <label class="label">KvK</label>
          <div class="control">
            <input class="input" type="text" v-model="settings['company.kvk']">
          </div>
        </div>

        <hr class="spacing">

        <div class="columns no-margin-bottom">
          <div class="field column">
            <label class="label">BTW nummer</label>
            <div class="control">
              <input class="input" type="text" v-model="settings['vat.number']">
            </div>
          </div>
        </div>

        <div class="field">
          <div class="field">
            <label class="label">BTW codes</label>
            <a @click="addVatCode" class="button is-primary">
              <span class="icon is-small">
                <i class="fa fa-plus"></i>
              </span>
              <span>New</span>
            </a>
          </div>
          <div class="columns">
            <div class="column">
              <p><b>Label</b></p>
            </div>
            <div class="column">
              <p><b>Inkoop</b></p>
            </div>
            <div class="column">
              <p><b>Verkoop</b></p>
            </div>
            <div class="column">
              <p><b>Percentage</b></p>
            </div>
            <div class="column is-2">
            </div>
          </div>
          <div class="columns" v-for="vat, index of settings['accountview.vat.codes']">
            <div class="column">
              <div class="control">
                <input class="input" type="text" v-model="vat.name">
              </div>
            </div>
            <div class="column">
              <div class="control">
                <input class="input" type="number" v-model="vat.purchase">
              </div>
            </div>
            <div class="column">
              <div class="control">
                <input class="input" type="number" v-model="vat.sales">
              </div>
            </div>
            <div class="column">
              <div class="control">
                <input class="input" type="number" v-model="vat.percentage">
              </div>
            </div>
            <div class="column is-2">
              <a @click="deleteVatCode(index)" class="button is-danger">
                <span class="icon is-small">
                  <i class="fa fa-times"></i>
                </span>
                <span>Delete</span>
              </a>
            </div>
          </div>
        </div>

        <hr class="spacing">

        <div class="field">
          <label class="label">AccountView key</label>
          <div class="control">
            <input class="input" type="text" v-model="settings['accountview.key']">
          </div>
        </div>

        <div class="field">
          <label class="label">AccountView secret</label>
          <div class="control">
            <input class="input" type="text" v-model="settings['accountview.secret']">
          </div>
        </div>

        <div class="field">
          <label class="label">AccountView company</label>
          <div class="control">
            <input class="input" type="text" v-model="settings['accountview.company']">
          </div>
        </div>

        <hr class="spacing">

        <div class="field">
          <label class="label">Email beheerder</label>
          <div class="control">
            <input class="input" type="text" v-model="settings['admin.email']">
          </div>
        </div>

        <hr class="spacing">

        <div class="field">
          <div class="field">
            <label class="label">Creditcard companies</label>
            <a @click="addCreditcardCompany" class="button is-primary">
              <span class="icon is-small">
                <i class="fa fa-plus"></i>
              </span>
              <span>New</span>
            </a>
          </div>
          <div class="columns" v-for="company, index of settings['creditcard.companies']">
            <div class="column">
              <div class="control">
                <input class="input" type="text" v-model="company.name">
              </div>
            </div>
            <div class="column">
              <div class="control">
                <input class="input" type="number" v-model="company.value">
              </div>
            </div>
            <div class="column is-2">
              <a @click="deleteCreditcardCompany(index)" class="button is-danger">
                <span class="icon is-small">
                  <i class="fa fa-times"></i>
                </span>
                <span>Delete</span>
              </a>
            </div>
          </div>
        </div>

        <hr class="spacing">

        <div class="field">
          <label class="label">AccountView inkoop dagboekcode</label>
          <div class="control">
            <input class="input" type="text" v-model="settings['accountview.inkoop.dagboekcode']">
          </div>
        </div>

        <div class="field">
          <label class="label">AccountView inkoop grootboekrekening</label>
          <div class="control">
            <input class="input" type="text" v-model="settings['accountview.inkoop.grootboekrekening']">
          </div>
        </div>

        <hr class="spacing">

        <div class="field">
          <label class="label">Volgend bonnummer</label>
          <div class="control">
            <input class="input" type="text" v-model="settings['latest.receipt.id']">
          </div>
        </div>

        <div class="field">
          <label class="label">Volgend inkoopfactuurnummer</label>
          <div class="control">
            <input class="input" type="text" v-model="settings['latest.purchase.id']">
          </div>
        </div>

        <hr class="spacing">

        <div class="field">
          <div class="field">
            <label class="label">Inkoop Artikelen</label>
            <a @click="addPurchaseArticle" class="button is-primary">
              <span class="icon is-small">
                <i class="fa fa-plus"></i>
              </span>
              <span>New</span>
            </a>
          </div>
          <div class="columns" v-for="article, index of settings['accountview.articles']">
            <div class="column">
              <div class="control">
                <input class="input" type="text" v-model="article.name">
              </div>
            </div>
            <div class="column">
              <div class="control">
                <input class="input" type="number" v-model="article.journal">
              </div>
            </div>
            <div class="column">
              <div class="control">
                <input class="input" type="number" v-model="article.value">
              </div>
            </div>
            <div class="column is-2">
              <a @click="deletePurchaseArticle(index)" class="button is-danger">
                <span class="icon is-small">
                  <i class="fa fa-times"></i>
                </span>
                <span>Delete</span>
              </a>
            </div>
          </div>
        </div>

        <hr class="spacing">

        <a class="button is-primary" @click="saveSettings" :class="{ 'is-loading': isSaving }">Opslaan</a>
      </div>
      <div>
        <div class="content notification is-primary has-white-text" style="margin-top:44px;">
          <h2>Systeem instellingen</h2>
          <p>Deze instellingen hebben invloed op de functionaliteiten van het systeem.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'settings'
    ])
  },
  data () {
    return {
      isSaving: false
    }
  },
  created () {
    this.$store.dispatch('getSettings', [
      'company.name',
      'company.address',
      'company.city',
      'company.country',
      'company.kvk',
      'company.iban',
      'accountview.secret',
      'accountview.key',
      'accountview.company',
      'admin.email',
      'vat.number',
      'latest.receipt.id',
      'latest.purchase.id',
      'accountview.vat.codes',
      'creditcard.companies',
      'accountview.inkoop.dagboekcode',
      'accountview.inkoop.grootboekrekening',
      'accountview.articles'
    ])
  },
  methods: {
    saveSettings () {
      this.isSaving = true

      this.$store.dispatch('saveSettings', this.settings)
      this.$snackbar.open('De instellingen zijn opgeslagen.')

      this.isSaving = false
    },
    deleteCreditcardCompany (index) {
      this.settings['creditcard.companies'].splice(index, 1)
    },
    addCreditcardCompany (index) {
      this.settings['creditcard.companies'].push({
        name: '',
        value: ''
      })
    },
    deletePurchaseArticle (index) {
      this.settings['accountview.articles'].splice(index, 1)
    },
    addPurchaseArticle (index) {
      this.settings['accountview.articles'].push({
        name: '',
        journal: '',
        article: ''
      })
    },
    deleteVatCode (index) {
      this.settings['accountview.vat.codes'].splice(index, 1)
    },
    addVatCode (index) {
      const codes = this.settings['accountview.vat.codes']
      let id = 1

      for (let code of codes) {
        if (code.id >= id) {
          id = code.id++
        }
      }

      this.settings['accountview.vat.codes'].push({
        id,
        name: '',
        purchase: '',
        sales: '',
        percentage: ''
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/settings/system.vue